import { render, staticRenderFns } from "./ClientUpdate.vue?vue&type=template&id=132c9046&"
import script from "./ClientUpdate.vue?vue&type=script&lang=ts&"
export * from "./ClientUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports